export default {"src":"/_next/static/media/Clearco.46288e58.svg","height":25,"width":119};